import { PRO_ROUTES } from "constants/proRoutes";
import messages from "messages";
import { Link } from "react-router-dom";
import Sources from "./components/sources";
import Imported from "./components/imported/Imported";
import DataTransferContextProvider from "./contexts/DataTransferContext";
import styles from "./styles.module.scss";

/**
 * renders the UI for pro dashboard data transfer page
 */
const DataTransfer = () => {
  return (
    <DataTransferContextProvider>
      <div className={styles["data-transfer__section"]}>
        {/* heading */}
        <hgroup className={styles["data-transfer__heading"]}>
          <h1 className={styles["data-transfer__title"]}>
            {messages.dataTransfer}
          </h1>
          <p className={styles["data-transfer__info"]}>
            {messages.transferYourPatientDataLine1}
          </p>
          <p className={styles["data-transfer__info"]}>
            {messages.transferYourPatientDataLine2Part1}
            <Link to={PRO_ROUTES.orchidStorage}>{messages.orchidStorage}</Link>
            {messages.transferYourPatientDataLine2Part2}
          </p>
        </hgroup>
        {/* import from */}
        <Sources />
      </div>
      <div className={styles["data-transfer__section"]}>
        {/* recent imports */}
        <Imported />
      </div>
    </DataTransferContextProvider>
  );
};

export default DataTransfer;
